const ListRow = ({ name, actionCheckBox, actionsNode, children }) => {
  return (
    <div className="pb-2 mt-2 border-b-2 border-gray-200">
      <div className="flex text-sm items-center">
        {actionCheckBox}
        <p className="w-full text-grey-darkest">{name}</p>
        {actionsNode}
      </div>
      {children}
    </div>
  );
};

const ListRowPlaceholder = ({ actionsNodeItems }) => {
  return (
    <div className="pulse-animate flex items-center mt-2 pb-2 border-b-2 border-gray-200">
      <div className="rounded h-8 w-12 mr-2 bg-gray-400"></div>
      <div className="rounded h-8 w-full mr-2 bg-gray-400"></div>

      <div className="rounded h-8 w-16 mr-2 bg-gray-400"></div>
      <div className="rounded h-8 w-16 bg-gray-400"></div>
    </div>
  );
};

export { ListRow, ListRowPlaceholder };
